import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
var AlertDialog = function (_a) {
    var open = _a.open, question = _a.question, statement = _a.statement, onClickOk = _a.onClickOk, onClickCancel = _a.onClickCancel, setOpen = _a.setOpen;
    var handleOk = function () {
        onClickOk();
        setOpen(false);
    };
    var handleCancel = function () {
        if (onClickCancel)
            onClickCancel();
        setOpen(false);
    };
    return (React.createElement(Dialog, { open: open, onClose: handleCancel, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
        React.createElement(DialogTitle, { id: "alert-dialog-title" }, question),
        statement ? (React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { id: "alert-dialog-description" }, statement))) : null,
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleCancel, color: "primary" }, "Cancel"),
            React.createElement(Button, { onClick: handleOk, color: "primary", autoFocus: true }, "OK"))));
};
export default AlertDialog;
